import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import ListIcon from '@material-ui/icons/List'
import { openMoadalAltaCiurcuito } from "../../../ducks/proveedorTerrestreDuck"

const BCircuitos = (props) => {
    const { idProveedor, clavePaquete, paquete } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openMoadalAltaCiurcuito({
            proveedor: {
                idProveedor: idProveedor,
                claveProveedor: clavePaquete,
            },
            paquete
        }))
    }

    return (
        <Tooltip title="Circuitos">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <ListIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BCircuitos